/* @jsxImportSource react */

import type { InstallmentCalulatorLayouts } from '../../types';
import { Collapsed } from './Collapsed/Collapsed';
import { CompactAndColumn } from './CompactAndColumn/CompactAndColumn';

export interface InstallmentCalculatorSuspenseFallbackProps {
  calculatorLayout: InstallmentCalulatorLayouts;
}

export const InstallmentCalculatorSuspenseFallback = ({
  calculatorLayout,
}: InstallmentCalculatorSuspenseFallbackProps) =>
  calculatorLayout === 'Collapsible' ? <Collapsed /> : <CompactAndColumn />;
